import React, { Component } from 'react';
import Plot from 'react-plotly.js';
import axios from 'axios';

export default class PlotlyGraph extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            layout: [],
            assetId: this.props.id,
            error: false,
            errorMessage: '',
            btnDisable: false,
            graphLoad: false,
            height: '100%',
            width: '100%'
        }
        this.closeErrorPop = this.closeErrorPop.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions.bind(this));
        window.removeEventListener("orientationchange", this.updateWindowDimensions.bind(this));
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));
        window.removeEventListener("orientationchange", this.updateWindowDimensions.bind(this));

        var assetId = this.state.assetId;
        var self = this;
        if (assetId !== 0 && assetId !== '') {
            axios
                .get(process.env.REACT_APP_BASE_URL + "graph/get-data/" + assetId)
                .then(function (response) {
                    if (response.status === 200) {
                        if (response.data.responseCode === 200) {
                            if (response.data.errorData === '') {
                                var data = response.data.outputData.data.data;
                                var layout = response.data.outputData.data.layout;
                                delete layout.height;
                                delete layout.width;
                                // layout["height"] = self.state.height;
                                // layout["width"] = self.state.width;
                                self.setState({
                                    data: data,
                                    layout: layout,
                                    graphLoad: true,
                                    error: false
                                });
                            }
                            else {
                                var element = document.getElementById("spinner");
                                element.display = 'none';
                                self.setState({
                                    data: [],
                                    layout: [],
                                    assetId: '',
                                    error: true,
                                    errorMessage: response.data.errorData.errorMessage
                                });
                            }
                        }
                    } else if (response.status === 400) {
                        self.setState({
                            data: [],
                            layout: [],
                            assetId: '',
                            error: true,
                            errorMessage: response.data.errorData.errorMessage
                        });
                        self.buttonDisable();
                    }
                })
                .catch(e => {
                    self.setState({
                        data: [],
                        layout: [],
                        assetId: '',
                        error: true,
                        errorMessage: "BAD_REQUEST"
                    });
                });
        }
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    closeErrorPop() {
        this.setState({
            error: false
        });
    }

    render() {
        return (
            <div className='col-sm p-0'>
                {
                    this.state.graphLoad ?
                        <Plot
                            data={this.state.data}
                            layout={this.state.layout}
                            config={{responsive: true}}
                            style={{height: this.state.height, width: this.state.width}}
                        />
                        : <h1><i class="fa fa-spinner fa-spin align-middle" id="spinner" aria-hidden="true"></i></h1>
                }
                {
                    this.state.error ?
                        <div class="alert alert-danger alert-dismissible fade show" role="alert">
                            {this.state.errorMessage}
                            <button type="button" class="close" onClick={this.closeErrorPop} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        : null
                }
            </div>
        );
    }
}